// extracted by mini-css-extract-plugin
export var background = "icon-ink-module--background--ccd4b";
export var image = "icon-ink-module--image--2b90c";
export var wrapper = "icon-ink-module--wrapper--0b721";